import { SERVICE_AREAS } from '../../../site';

export default function ServiceAreas() {
  return (
    <section id="service-areas" className="py-28 px-6 bg-[#f7f8fa]">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center max-w-[720px] mx-auto mb-16">
          <p className="text-[13px] font-bold tracking-[0.09em] uppercase text-[#0b5b96] mb-[14px]">Service Areas</p>
          <h2 className="font-extrabold text-[#161a20] leading-[1.15] tracking-tight mb-5" style={{ fontSize: 'clamp(2.25rem,4vw,3rem)' }}>
            Commercial Cleaning Across the Fredericksburg Region
          </h2>
          <p className="text-lg leading-relaxed text-[#5b6472]">
            Based in Fredericksburg, we clean offices and commercial spaces throughout the surrounding counties and Northern Virginia.
          </p>
        </div>

        {/* Areas Grid */}
        <ul className="grid gap-6" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))' }}>
          {SERVICE_AREAS.map((area) => (
            <li
              key={area.name}
              className="bg-white rounded-[20px] p-[30px] border border-[#edeef0] shadow-[0_1px_2px_rgba(16,24,40,0.03)] transition-all duration-250 hover:shadow-[0_20px_40px_-18px_rgba(16,24,40,0.18)] hover:-translate-y-1"
            >
              <div className="w-12 h-12 rounded-[14px] bg-[#5FA42B]/[.18] flex items-center justify-center mb-[18px]">
                <i className="ri-map-pin-2-line text-[22px] text-[#0b5b96]"></i>
              </div>
              <h3 className="text-[19px] font-bold text-[#161a20] mb-2">{area.name}</h3>
              <p className="text-[15px] leading-relaxed text-[#5b6472] mb-4">{area.blurb}</p>
              <a href={area.href} className="inline-flex items-center gap-2 font-bold text-[15px] text-[#0b5b96] hover:text-[#084876]">
                {area.linkText}
                <i className="ri-arrow-right-line"></i>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
